// Record a sign-in: profiles.last_login and an append-only login_events row.
//
// This used to live in VerifyPage, which never mounts on a successful sign-in
// (the magic link's session is taken from the URL during client start-up, and
// RedirectIfAuthenticated moves the reader on before VerifyPage renders), so
// neither was ever written and the admin dashboard's sign-in figures read zero.
//
// Now auth-context calls this whenever it sees a session. A restored session
// and a fresh sign-in look the same from here, so the key is the session's own
// last_sign_in_at: GoTrue sets it on each real sign-in, and we record each value
// once per browser.

type Db = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  from: (table: string) => any;
};

type SessionUser = { id: string; last_sign_in_at?: string | null };

const KEY_PREFIX = "dr:login-recorded:";

export async function recordLogin(
  db: Db,
  user: SessionUser,
  storage: Pick<Storage, "getItem" | "setItem"> = window.localStorage
): Promise<boolean> {
  const at = user.last_sign_in_at;
  if (!at) return false;

  const key = KEY_PREFIX + user.id;
  if (storage.getItem(key) === at) return false;
  // Mark first: two tabs waking on the same session must not both insert.
  storage.setItem(key, at);

  // supabase-js reports failure in { error } rather than throwing. Forget the
  // mark on failure so the next page load tries again.
  const updated = await db.from("profiles").update({ last_login: at }).eq("id", user.id);
  const inserted = await db.from("login_events").insert({ user_id: user.id, logged_in_at: at });
  if (updated?.error || inserted?.error) {
    storage.setItem(key, "");
    return false;
  }
  return true;
}
